import React, { useState, useEffect } from 'react';
import InstanceList from './InstanceList';
import FilterBar from './FilterBar';
import { useMsal } from '@azure/msal-react';

const Dashboard = ({ 
  instances, 
  loading, 
  error, 
  onStart, 
  onStop, 
  onRefresh,
  showOnlyWorkspaces,
  totalInstanceCount,
  accounts,
  pollingInstances
}) => {
  const { accounts: msalAccounts } = useMsal();
  const user = msalAccounts.length > 0 ? msalAccounts[0] : null;
  const [filteredInstances, setFilteredInstances] = useState(instances);
  const [filters, setFilters] = useState({
    state: 'all',
    account: 'all'
  });

  useEffect(() => {
    // Filter out Anfexi account instances
    let result = instances.filter(instance => {
      const accountInfo = accounts?.find(acc => acc.id === instance.accountId);
      return !(accountInfo && accountInfo.name === 'Anfexi');
    });
    
    // Filter by state
    if (filters.state !== 'all') {
      result = result.filter(instance => instance.state === filters.state);
    }

    // Filter by account
    if (filters.account !== 'all') {
      result = result.filter(instance => instance.accountId === filters.account);
    }
    
    setFilteredInstances(result);
  }, [instances, filters, accounts]);

  const handleFilterChange = (filterType, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [filterType]: value
    }));
  };

  return (
    <div className="w-full px-0 sm:px-4 py-6">
      {/* Error message */}
      {error && (
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6" role="alert">
          <p>{error}</p>
        </div>
      )}

      <FilterBar 
        filters={filters} 
        onFilterChange={handleFilterChange} 
        instanceCount={filteredInstances.length}
        totalCount={instances.length}
        accounts={accounts?.filter(account => account.name !== 'Anfexi')}
      />

      {/* Add 10px spacing between filter and results */}
      <div className="h-[10px]"></div>

      {/* Instances */}
      <div className="bg-white rounded-lg shadow-md p-4 w-full">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-gray-800">
            EC2 Instances 
            {showOnlyWorkspaces && (
              <span className="ml-2 text-sm text-gray-500 font-normal">
                (Workspace instances only: {instances.length} of {totalInstanceCount})
              </span>
            )}
          </h3>
        </div>
        <InstanceList 
          instances={filteredInstances} 
          loading={loading} 
          onStart={onStart} 
          onStop={onStop}
          pollingInstances={pollingInstances}
        />
      </div>
    </div>
  );
};

export default Dashboard; 